/** Canonical (AWS-style) Secret Manager id of a Cloudflare account's install
 * token. Other providers rewrite it with their `replacer`. */
export const cloudflareAiInstallTokenSecretId = (itemId: string): string =>
  `p0/install/cloudflare/${itemId}/install-token`;

/** Canonical prefix that every grant token secret of a Cloudflare account
 * starts with. Other providers rewrite it with their `replacer`. */
export const cloudflareAiAccessTokenPrefix = (itemId: string): string =>
  `p0/access-token/cloudflare/${itemId}/`;

/** The connector's Cloud Run service name. Its Lambda function name adds
 * "-aws". */
export const cloudflareAiConnectorName = "p0-connector-cloudflare-ai";
